// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2_CI5","legacyBtn":"MutateMid_legacyBtn__1Qa25"};